import ReactGA from 'react-ga4';

export const clickInformation = () => {
  ReactGA.event({
    category: 'loan_detail_page',
    action: 'information_button_pressed',
  });
};

export const clickShowLoanAgreement = () => {
  ReactGA.event({
    category: 'loan_detail_page',
    action: 'show_sphp_button_pressed',
  });
};
